import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api, { unwrap } from '../utils/api';

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [cart, setCart] = useState({ items: [] });

  const refresh = useCallback(async () => {
    try {
      const r = await api.get('/cart/getCart');
      setCart(unwrap(r) || { items: [] });
    } catch (_) {
      setCart({ items: [] });
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  async function addItem(productId, fieldValues, extra = {}) {
    const r = await api.post('/cart/addItemToCart', { productId, fieldValues, ...extra });
    setCart(unwrap(r));
  }

  async function removeItem(itemId) {
    const r = await api.post('/cart/deleteFromCart', { itemId });
    setCart(unwrap(r));
  }

  async function applyCoupon(code) {
    const r = await api.post('/cart/applyCoupon', { code });
    const body = unwrap(r);
    setCart(body.cart);
    return body;
  }

  async function checkout() {
    const r = await api.post('/cart/process-payment', {});
    setCart({ items: [] });
    return unwrap(r);
  }

  return (
    <CartContext.Provider value={{ cart, refresh, addItem, removeItem, applyCoupon, checkout }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
